export default __webpack_public_path__ + "static/RC-vert-1dcc3344735dc841e7ef4b30e12eead9.svg";